export default __webpack_public_path__ + "static/media/logo.2220bd34.svg";